export default "__VITE_ASSET__CdaNa5Uq__"